import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

function PublicLayout() {
  const { pathname } = useLocation();
  // En el home el hero se extiende detrás del nav transparente.
  const isHome = pathname === '/';

  return (
    <>
      <Header />
      <main style={{ paddingTop: isHome ? 0 : '64px' }}>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

export default PublicLayout;
